import { IonCol, IonGrid, IonImg, IonRow } from "@ionic/react";
import React from "react";
import { getAppointmentTime } from '../../../utils/formatData';

import "./loadStops.scss";

export const LoadStop: React.FunctionComponent<any> = (props: any) => {
  const loadStops: any[] = props.loadStops || [];
  return (
    <React.Fragment>
      <IonGrid class={`load-stop-grid ${props.className || ""}`}>
        {loadStops.map((stopDetail: any, index: number) => {
          return (
            <React.Fragment key={"load-stop-" + index}>
              <IonRow className="load-stop-grid-row">
                <IonCol size="12" className="load-stop-grid-col">
                  {index < loadStops.length - 1 ? (
                    <>
                      {index === 0 ? (
                        <IonImg
                          className="stop-icon origin-pointer"
                          src="assets/icon/origin-pointer.svg"
                        />
                      ) : (
                        <IonImg
                          className="stop-icon stop-pointer"
                          src="assets/icon/stop-pointer.svg"
                        />
                      )}
                    </>
                  ) : (
                    <IonImg
                      className="stop-icon dst-pointer"
                      src="assets/icon/dst-pointer.svg"
                    />
                  )}
                  <div className="load-stop-text-details">
                    <p className="origin_city load-stop-name">
                      {`${stopDetail && stopDetail.city}, ${stopDetail &&
                        stopDetail.state}`}
                    </p>
                    <p className="origin_dateTime load_header_elements stop-appointment">
                      {props.calculateTime && props.calculateTime(stopDetail) || getAppointmentTime(stopDetail)}
                    </p>
                  </div>
                </IonCol>
              </IonRow>
            </React.Fragment>
          );
        })}
      </IonGrid>
    </React.Fragment>
  );
};
